import React from "react";
import { useTranslation } from "react-i18next";
import { Box } from "@mui/material";
import { useMyCafeteriaRegulation } from "my-cafeteria/hooks";
import { OcCard, OcFileViewerAndDownloaderBox } from "oc/components";

export const MyCafeteriaDownloadsCard = () => {
  const { t } = useTranslation();
  const { data } = useMyCafeteriaRegulation();
  return (
    <Box>
      <OcCard label={t("OC_DOWNLOADS")}>
        <OcFileViewerAndDownloaderBox
          label={t("MY_CAFETERIA_VBK_REGULATION")}
          href={data?.filename}
          modul="cafeteria"
        />
      </OcCard>
    </Box>
  );
};

export default MyCafeteriaDownloadsCard;
